<template>
  <b-card class="card-painel">
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col>
            <legend class="col-form-label pt-0">
              Filtrar por
            </legend>
            <b-select
              v-model="filtro.filtroDataPesquisa"
              name="filtroDataPesquisa"
              class="search-items"
            >
              <option
                v-for="(cert, index) in filtroCertificado"
                :key="index"
                :value="cert.value"
              >{{ cert.text }}
              </option>
            </b-select>
          </b-col>
          <b-col
            cols="4"
          >
            <div class="w-100">
              <legend class="col-form-label pt-0">
                &nbsp;
              </legend>
              <de-para
                ref="dataEnvioCobranca"
                v-model="filtro.cobrancaEnvio"
              />
            </div>
            <span
              v-if="avisoDataFinal()"
              style="color: red;
                    font-size: small;
                    display: flex;
                    margin-top: 4px;
                    margin-left: 80px;"
            >
              A data final nao pode ser menor que a data inicial!
            </span>
          </b-col>
          <b-col
            cols="4"
            class="mr-auto"
          >
            <responsavel-select
              ref="filtroGerente"
              v-model="filtro.gerentes"
              :multiple="true"
              :label="'Responsável (Auditar)'"
            />
            <!-- <b-form-checkbox
              v-model="filtro.mostrarRejeitadasEExpiradas"
              :value="false"
              :unchecked-value="false"
            >
              Mostrar propostas rejeitadas e expiradas
            </b-form-checkbox> -->
          </b-col>
          <b-col cols="auto">
            <legend class="col-form-label pt-0">
              &nbsp;
            </legend>

            <div style="padding-top:6.218px; display: flex;">
              <div>
                <b-btn
                  v-b-tooltip.hover
                  title="Exportar relatorio com base nos filtros aplicados"
                  variant="success"
                  class="btn-sm mr-50"
                  @click="downloadPlanilhaPropostas"
                >
                  <font-awesome-icon
                    :icon="faDownload"
                  />
                </b-btn>
                <a
                  id="download"
                  download
                  href=""
                  hidden
                />
              </div>
              <div>
                <b-btn
                  v-b-tooltip.hover
                  title="Exportar planilha de dados do financeiro"
                  variant="none"
                  class="btn-primary btn-sm mr-50"
                  @click="downloadPlanilha"
                >
                  <font-awesome-icon
                    :icon="faDownload"
                  />
                </b-btn>
                <a
                  id="download"
                  download
                  href=""
                  hidden
                />
              </div>
              <div
                style="display: inline-block;"
                tabindex="0"
                class="linha-vertical"
              >
                <b-btn
                  id="popover-filtro"
                  variant="none"
                  class="btn-primary btn-sm mr-50"
                >
                  <feather-icon
                    style="margin-right:0.25rem"
                    icon="FilterIcon"
                  />Filtros</b-btn>
              </div>
              <div style="display: contents;">
                <b-btn
                  variant="none"
                  class="btn-primary btn-sm mr-50 ml-50"
                  @click.prevent.stop="limpar()"
                >Limpar</b-btn>
                <b-btn
                  :disabled="avisoDataFinal()"
                  variant="none"
                  class="btn-primary btn-sm"
                  @click="aplicar(true)"
                >Aplicar</b-btn>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row style="justify-content: center;">
          <b-col cols="auto">
            <div
              v-if="filtro.filtroAplicadoUsuario"
              class="aviso-filtro"
              style="width: fit-content;"
            >
              Atenção: no botão de Filtros existem filtros customizados aplicados na visualização dos dados do painel!
            </div>
          </b-col>
        </b-row>
        <div class="row quadro-lista">
          <div
            v-for="(lista, $index) in listas"
            :key="$index"
            class="lista"
          >
            <lista-cartao
              :value="lista.propostas"
              :titulo="lista.titulo"
              :color="lista.color"
              :coluna="lista.coluna"
              :total="lista.total"
              :valor-total="lista.valorTotal"
            />
          </div>
          <router-view />
        </div>
      </b-col>
    </b-row>
    <filtro-adicional :value="filtro" />
    <loading
      :is-loading="isLoading"
      :show-cancel-button="false"
      :show-message="'Aguarde, carregando os dados!'"
      :trocar-cor-letra="true"
    />
  </b-card>
</template>

<style lang="scss">
.quadro-lista {
   margin-right: 0;
   display: block;
   overflow-x: auto;
   overflow-y: hidden;
   white-space: nowrap;
   padding: 0px 0.5rem;
   padding-bottom: 4px;
   height: calc(100vh - 300px);
  //height: 355px;//655px;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

.lista {
  display: inline-block;
  margin: 0 4px;
  box-sizing: border-box;
  vertical-align: top;
  white-space: nowrap;
  height: 100%;
  width: 15%;
  min-width: 280px;
}

.card-painel {
  line-height: 1.25;
}

.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.aviso-filtro {
  text-align: left;
  font-size: 13px;
  background-color: lightgoldenrodyellow;
  padding: 0.2rem;
  border-radius: 0.3rem;
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faDownload,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/proposta/shared/services/api'

export default {
  name: 'PainelPropostas',
  components: {
    FontAwesomeIcon,
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    ListaCartao: () => import('@/app-modulo/comercial/proposta/shared/components/lista/Lista.vue'),
    FiltroAdicional: () => import('@/app-modulo/comercial/proposta/shared/components/filtro-adicional/FiltroAdicional.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
  },
  data() {
    return {
      // listas: [],
      faDownload,
      now: new Date(),
      isLoading: true,
      filtroCertificado: [
        { text: 'Data de envio', value: 0 },
        { text: 'Data de aprovação', value: 1 },
        { text: 'Data de rejeição', value: 2 },
        { text: 'Data de expiração', value: 3 },
      ],
    }
  },
  computed: {
    ...mapGetters('listas', ['listas', 'filtro']),
  },
  created() {
    this.isLoading = true
    api.getFiltroIniciais()
      .then(payload => {
        const filtros = payload.data

        if (filtros.validade && filtros.validade.dataInicio && filtros.validade.dataFim) {
          filtros.validade.dataInicio = moment(filtros.validade.dataInicio).format('DD/MM/YYYY')
          filtros.validade.dataFim = moment(filtros.validade.dataFim).format('DD/MM/YYYY')
        }

        this.filtro = filtros
        this.filtro.gerentes = filtros.gerentes

        this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)

        this.getInitialPeriod()

        this.aplicar(false)
      })
      .catch(err => {
        this.isLoading = false
        throw err
      }).finally(() => {
        this.isLoading = false
      })
  },
  methods: {
    ...mapActions('listas', ['setListas', 'limparFiltro']),
    aplicar(manual) {
      this.setListas([])
      this.isLoading = true
      api.getPropostas(this.filtro, manual)
        .then(payload => {
          const result = payload.data
          this.filtro.filtroAplicadoUsuario = result.filtroAplicadoUsuario
          delete result.filtroAplicadoUsuario
          this.setListas(result)
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          throw err
        })
    },
    avisoDataFinal() {
      const cobrancas = this.filtro.cobrancaEnvio
      const dataInicio = cobrancas.dataInicio != null ? cobrancas.dataInicio.split('/') : null
      const dataFim = cobrancas.dataFim != null ? cobrancas.dataInicio.split('/') : null

      if (cobrancas.dataFim === null || cobrancas.dataFim === '') {
        return false
      }
      return (moment(new Date(dataInicio[2], dataInicio[1] - 1, dataInicio[0]))) > (moment(new Date(dataFim[2], dataFim[1] - 1, dataFim[0])))
    },
    getInitialPeriod() {
      const dateInicio = (moment(new Date(this.now)).subtract(6, 'months')).toDate()
      const dateFim = (moment(new Date(this.now))).toDate()

      this.filtro.cobrancaEnvio = {
        dataInicio: `${dateInicio.getDate() < 10 ? `0${dateInicio.getDate()}` : dateInicio.getDate()}/${dateInicio.getMonth() + 1 < 10 ? `0${dateInicio.getMonth() + 1}` : dateInicio.getMonth() + 1}/${dateInicio.getFullYear()}`,
        dataFim: `${dateFim.getDate() < 10 ? `0${dateFim.getDate()}` : dateFim.getDate()}/${dateFim.getMonth() + 1 < 10 ? `0${dateFim.getMonth() + 1}` : dateFim.getMonth() + 1}/${dateFim.getFullYear()}`,
      }
    },
    limpar() {
      this.limparFiltro()

      this.palavraChave = null

      this.getInitialPeriod()
    },

    validaData(dataInicial, dataFinal) {
      const diff = moment(dataFinal, 'DD/MM/YYYY HH:mm:ss').diff(moment(dataInicial, 'DD/MM/YYYY HH:mm:ss'))
      const diffMes = moment.duration(diff).asMonths()
      return diffMes > 6.1
    },
    downloadPlanilha() {
      const datas = []
      if (this.filtro.cobrancaEnvio.dataInicio || this.filtro.cobrancaEnvio.dataInicio !== '') {
        datas.push(this.filtro.cobrancaEnvio.dataInicio)
        datas.push(this.filtro.cobrancaEnvio.dataFim)
        this.$isLoading(true)
        api.getPlanilhaFinanceiro(datas)
          .then(payload => {
            if (payload.data.url !== '') {
              document.getElementById('download').href = payload.data.url
              document.getElementById('download').click()
            }
            this.deletarUpload(payload.data.fileName)
          }).catch(err => {
            this.$erroResponse(err)
            throw err
          })
          .finally(() => {
            this.$isLoading(false)
          })
      } else {
        this.$erro('É necessário escolher data inicial e data final')
      }
    },
    downloadPlanilhaPropostas() {
      this.$isLoading(true)
      api.getPlanilhaPropostas(this.filtro)
        .then(payload => {
          if (payload.data.url !== '') {
            document.getElementById('download').href = payload.data.url
            document.getElementById('download').click()
          }
          this.deletarUpload(payload.data.fileName)
        }).catch(err => {
          this.$erroResponse(err)
          throw err
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(resolve => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
            resolve()
          })
      }, 3000)
    },
  },
}
</script>
